import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import {
  SectionContainer,
  SectionTitle,
  PurpleText,
} from '../common/components';
import { Github } from './Github';
import { Techstack } from './TechStack/Techstack';
import { AboutCard } from './AboutCard';
import { Atom3D } from './Atom3D';

export const About = (): React.ReactNode => {
  return (
    <SectionContainer>
      <Container maxWidth='lg'>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center',
            gap: 4,
            mb: 6,
          }}
        >
          <Box sx={{ flex: { md: '0 0 58%' } }}>
            <Typography
              variant='h2'
              sx={{
                fontSize: { xs: '1.8rem', md: '2.1rem' },
                fontWeight: 'bold',
                mb: 4,
                textAlign: { xs: 'center', md: 'left' },
              }}
            >
              Who am{' '}
              <Box
                component='span'
                sx={{
                  color: 'primary.main',
                  fontWeight: 'bold',
                }}
              >
                I
              </Box>
              ?
            </Typography>
            <AboutCard />
          </Box>

          <Box
            sx={{
              flex: { md: '0 0 42%' },
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Atom3D />
          </Box>
        </Box>

        <SectionTitle variant='h2'>
          Professional <PurpleText>Skillset</PurpleText>
        </SectionTitle>

        <Techstack />

        <Github />
      </Container>
    </SectionContainer>
  );
};
